import React from "react";

const RLNavItemLabel: React.FC<{
  text: string;
}> = ({ text }) => (
  <div className="rl-nav__top-level-label">
    <span
      className="rl-nav__top-level-label-text"
      data-testid="rl_nav_item_top_level_label_text"
    >
      {text}
    </span>
  </div>
);

export default RLNavItemLabel;
